import type { FilterNode } from '@qronstat/shared';
import type { MetaIndex } from './meta';

export function groupMember(typeCode: string): string {
  return `grp_${typeCode}.group_id`;
}

export function objectMember(
  meta: MetaIndex | null,
  type: string,
  groupTypeCode?: string | null,
): string | null {
  if (type === 'group') return groupTypeCode ? groupMember(groupTypeCode) : null;
  return meta?.object(type)?.key ?? null;
}

export function objectFilter(
  meta: MetaIndex | null,
  type: string,
  ids: string[],
  groupTypeCode?: string | null,
): FilterNode | null {
  const member = objectMember(meta, type, groupTypeCode);
  if (!member || !ids.length) return null;
  return { member, operator: 'equals', values: ids };
}

export function objectTypeOfLabel(meta: MetaIndex | null): (member: string) => string | null {
  return (member) => meta?.meta.objects.find((o) => o.listable && o.label === member)?.type ?? null;
}
